import React, { useState } from "react";

const HesapSilme = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleConfirm = (email, password) => {
    if (email === undefined || password === undefined) {
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/hesap-silme`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          window.alert(
            "Çok fazla istek ya da hata oluştu. Daha sonra tekrar deneyiniz."
          );
          throw new Error("İstek başarısız oldu");
        }
        return response.json();
      })
      .then((result) => {
        console.log(result);
        if (result["message"] == "basarili") {
          setIsSubmitted(true);
        } else if (result["message"] == "Şifre ya da kullanıcı adı yanlış!") {
          window.alert("Şifre ya da kullanıcı adı yanlış!");
        } else if (result["message"] == "Server error!") {
          window.alert("Sunucu hatası oldu.");
        } else if (result["message"] == "kullanici kayitli degil!") {
          window.alert("Kayıtlı kullanıcı bulunamadı.");
        } else if (result["message"] == "Eksik bilgi!") {
          window.alert("Eksik bilgi.");
        } else if (result["message"] == "sce") {
          window.alert("Sunucu hatası oldu.");
        } else if (result["message"] == "Sunucu Hatasi!") {
          window.alert("Sunucu hatası oldu.");
        } else if (result["message"] == "se") {
          window.alert("Sunucu hatası oldu.");
        }
      })
      .catch((error) => {
        console.warn("İşlem sırasında hata.");
      });

    setShowModal(false);
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">
                Hesap Silme Talebi
              </h3>

              {!isSubmitted ? (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email adresiniz
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Şifreniz
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-danger">
                      Hesabımı Sil
                    </button>
                  </div>
                </form>
              ) : (
                <div className="alert alert-success text-center">
                  <h5>Talebiniz Alındı!</h5>
                  <p>
                    Hesap silme talebiniz başarıyla alınmıştır. En kısa sürede
                    işleme alınacaktır.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Onay Modalı */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Onay</h5>
              <button
                type="button"
                className="btn btn-close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                x
              </button>
            </div>
            <div className="modal-body">
              <p>
                Hesabınızı silmek istediğinizden emin misiniz? Bu işlem geri
                alınamaz.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Vazgeç
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => handleConfirm(formData.email, formData.password)}
              >
                Eminim, Hesabımı Sil
              </button>
            </div>
          </div>
        </div>
      </div>

      {showModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default HesapSilme;
